export function isOnSmallScreen() {
  return window.matchMedia("(max-width: 768px)").matches;
}
